import script from "./NavButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavButton.vue?vue&type=script&setup=true&lang=ts"

import "./NavButton.vue?vue&type=style&index=0&id=5bb236a3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb236a3"]])

export default __exports__